import { WF_GROUP_REGISTRY, WF_TYPE_REGISTRY, WorkflowExitTypeInfo } from '../../services/workflow.service';
import {
    ExecuteStoredProcedureSettings
} from '../../workflow/modules/containeroperations/executestoredprocedure/execute.stored.procedure.settings';
import { AddColumnsSettings } from '../../workflow/modules/dataoperations/addcolumns/addcolumns.settings';
import { AggregateSettings } from '../../workflow/modules/dataoperations/aggregate/aggregate.settings';
import { AnomalyDetectionSettings } from '../../workflow/modules/dataoperations/ai/anomalydetection/anomaly.detection.settings';
import { AugmentControl } from '../../workflow/modules/dataoperations/ai/augment.control';
import { ClusteringSettings } from '../../workflow/modules/dataoperations/ai/clustering/clustering.settings';
import { CorrelationSettings } from '../../workflow/modules/dataoperations/ai/correlation/correlation.settings';
import { LuisValueSettings } from '../../workflow/modules/dataoperations/ai/luis/luis.settings';
import {
    MultiAnomalyDetectionSettings
} from '../../workflow/modules/dataoperations/ai/multianomalydetection/multi.anomaly.detection.settings';
import { MultiFeatureModelSettings } from '../../workflow/modules/dataoperations/ai/multifeaturemodel/multi.feature.model.settings';
import {
    MultiFeaturePredictionSettings
} from '../../workflow/modules/dataoperations/ai/multifeatureprediction/multi.feature.prediction.settings';
import { RegionControl } from '../../workflow/modules/dataoperations/ai/region.control';
import { SingleFeatureModelSettings } from '../../workflow/modules/dataoperations/ai/singlefeaturemodel/single.feature.model.settings';
import {
    SingleFeaturePredictionSettings
} from '../../workflow/modules/dataoperations/ai/singlefeatureprediction/single.feature.prediction.settings';
import {
    TextClassificationModelSettings
} from '../../workflow/modules/dataoperations/ai/textclassificationmodel/text.classification.model.settings';
import {
    TextClassificationPredictSettings
} from '../../workflow/modules/dataoperations/ai/textclassificationpredict/text.classification.predict.settings';
import { ChangeDataTypeSettings } from '../../workflow/modules/dataoperations/changedatatype/changedatatype.settings';
import { CheckNullSettings } from '../../workflow/modules/dataoperations/checknull/checknull.settings';
import { ClearDeltaInfoSettings } from '../../workflow/modules/dataoperations/cleardeltainfo/cleardeltainfo.settings';
import {
    DatasourceObjectSettings, DataSourcePreviewPanel, DatasourceSettings
} from '../../workflow/modules/dataoperations/datasource/datasource.settings';
import { EditColumnsSettings } from '../../workflow/modules/dataoperations/editcolumns/editcolumns.settings';
import {
    ExecuteOnActualDataSettingsData, ExecuteOnActualObjectSettingsData
} from '../../workflow/modules/dataoperations/executeonactual/executeonactual.settings';
import {
    ColumnDialog, ExportDataSettings, ExportObjectSettings
} from '../../workflow/modules/dataoperations/exportdata/exportdata.settings';
import { GenerateReaderSettings } from '../../workflow/modules/dataoperations/generatereader/generate.reader.settings';
import { PivotSettings } from '../../workflow/modules/dataoperations/pivot/pivot.settings';
import { PythonSettings } from '../../workflow/modules/dataoperations/python/python.settings';
import { ReadRowDataSettings } from '../../workflow/modules/dataoperations/readrowdata/readrowdata.settings';
import { RelToObjectObjectSettings } from '../../workflow/modules/dataoperations/reltoobject/reltoobject.object.settings';
import { RelToObjectSettings } from '../../workflow/modules/dataoperations/reltoobject/reltoobject.settings';
import { SimpleComparisonSettings } from '../../workflow/modules/dataoperations/simplecomparison/simplecomparison.settings';
import { UnionDatasourceSettingsDataHelper } from '../../workflow/modules/dataoperations/uniondatasource/unionds.settings';
import { UnpivotSettings } from '../../workflow/modules/dataoperations/unpivot/unpivot.settings';
import {
    GenerateDocumentStructureSettings
} from '../../workflow/modules/documentoperations/generatedocumentstructure/generate.document.structure.settings';
import {
    GetObjectAndTemplateFromPythontStructureSettings
} from '../../workflow/modules/documentoperations/getobjectandtemplatefrompython/get.object.and.template.from.python';
import {
    GetObjectFromDocumentStructureSettings
} from '../../workflow/modules/documentoperations/getobjectfromdocumentstructure/get.object.from.document.structure.settings';
import { TextRecognitionSettings } from '../../workflow/modules/documentoperations/textrecognition/text.recognition.settings';
import { DeleteResourceSettings } from '../../workflow/modules/fileoperations/deleteresource/delete.resource.settings';
import { LoadResourceSettings } from '../../workflow/modules/fileoperations/loadresource/load.resource.settings';
import { SaveResourceSettings } from '../../workflow/modules/fileoperations/saveresource/save.resource.settings';
import { WriteToTCPSettings } from '../../workflow/modules/fileoperations/writetotcp/write.to.tcp.settings';
import { FillKPISettings } from '../../workflow/modules/kpi/fillkpi/fill.kpi.settings';
import { ReadKPISettings } from '../../workflow/modules/kpi/readkpi/read.kpi.settings';
import { AddPropertiesSettings } from '../../workflow/modules/objectoperations/addproperties/add.properties.settings';
import { PythonObjectSettings } from '../../workflow/modules/objectoperations/ai/python.object.settings';
import { EditPropertiesSettings } from '../../workflow/modules/objectoperations/editproperties/editproperties.settings';
import { GenerateObjectReaderSettings } from '../../workflow/modules/objectoperations/generatereader/generate.object.reader.settings';
import { ObjectPropertyChooser } from '../../workflow/modules/objectoperations/object.property.chooser';
import { ObjectToRelSettings } from '../../workflow/modules/objectoperations/objecttorel/objecttorel.settings';
import { ReadObjectPropertiesSettings } from '../../workflow/modules/objectoperations/readobjectprops/readobjectprops.settings';
import { ReplaceEnumSettings } from '../../workflow/modules/objectoperations/replaceenum/replaceenum.settings';
import { ExecuteRestEndPointSettings } from '../../workflow/modules/rest/execute.rest.endpoint.settings';
import { RestObjectInfoDialog } from '../../workflow/modules/rest/rest.object.info.dialog';
import { AgentRestSettings } from '../../workflow/modules/restCall/agent.rest.settings';
import { AskKISettings } from '../../workflow/modules/ki/askki/askki.settings';
import { EmbedSettings } from '../../workflow/modules/ki/embed/embed.settings';
import { OcrSettings } from '../../workflow/modules/ki/ocr/ocr.settings';
import { TranscribeSettings } from '../../workflow/modules/ki/transcribe/transcribe.settings';
import { VectorQuerySettings } from '../../workflow/modules/ki/vectorquery/vectorquery.settings';
import { SendMessageSettings } from '../../workflow/modules/sendmessage/sendmessage.settings';
import { TriggerMessageSettings } from '../../workflow/modules/sendmessage/trigger.message.settings';
import { ShowWizardDialog } from '../../workflow/modules/showwizard/show.wizard.dialog';
import { ShowWizardSettings } from '../../workflow/modules/showwizard/show.wizard.settings';
import { WorkflowRegistryHelper } from './workflow.registry';


export const MW_WORKFLOW = [
    AddColumnsSettings,
    AggregateSettings,
    ChangeDataTypeSettings,
    DatasourceSettings,
    DatasourceObjectSettings,
    DataSourcePreviewPanel,
    EditColumnsSettings,
    ExportDataSettings,
    ExportObjectSettings,
    ColumnDialog,
    PivotSettings,
    PythonSettings,
    PythonObjectSettings,
    UnpivotSettings,
    ClusteringSettings,
    CorrelationSettings,
    LuisValueSettings,
    AnomalyDetectionSettings,
    SingleFeatureModelSettings,
    MultiAnomalyDetectionSettings,
    SingleFeaturePredictionSettings,
    MultiFeatureModelSettings,
    MultiFeaturePredictionSettings,
    AugmentControl,
    RelToObjectSettings,
    RelToObjectObjectSettings,
    ObjectToRelSettings,
    ClearDeltaInfoSettings,
    SimpleComparisonSettings,
    ReadRowDataSettings,
    EditPropertiesSettings,
    ObjectPropertyChooser,
    ReplaceEnumSettings,
    ReadObjectPropertiesSettings,
    SendMessageSettings,
    TriggerMessageSettings,
    LoadResourceSettings,
    SaveResourceSettings,
    DeleteResourceSettings,
    RegionControl,
    WriteToTCPSettings,
    GenerateReaderSettings,
    FillKPISettings,
    ReadKPISettings,
    ShowWizardSettings,
    ShowWizardDialog,
    TextClassificationModelSettings,
    TextClassificationPredictSettings,
    GenerateDocumentStructureSettings,
    GetObjectFromDocumentStructureSettings,
    GetObjectAndTemplateFromPythontStructureSettings,
    GenerateObjectReaderSettings,
    AddPropertiesSettings,
    ExecuteRestEndPointSettings,
    RestObjectInfoDialog,
    AgentRestSettings,
    ExecuteStoredProcedureSettings,
    TextRecognitionSettings,
    CheckNullSettings,
    AskKISettings,
    EmbedSettings,
    TranscribeSettings,
    VectorQuerySettings,
    OcrSettings
];

export class MWWorkflowRegistryHelper {
    public static Build() {
        // Module
        MW_WORKFLOW.forEach(wf => {
            if (typeof wf['GetRegistry'] === 'function') {
                WorkflowRegistryHelper.ExternalWorkflowRegistry.push(wf);
            }
        });
        WorkflowRegistryHelper.ExternalWorkflowRegistry.push(...[UnionDatasourceSettingsDataHelper,
            ExecuteOnActualDataSettingsData, ExecuteOnActualObjectSettingsData]);

        // Gruppen
        WF_GROUP_REGISTRY.push({
            Caption: '@@Relationale Operationen',
            GroupID: 'reldataoperations',
            Index: 30,
            ParentID: null,
            Icon:'wf_group_reldataoperations'
        });
        WF_GROUP_REGISTRY.push({
            Caption: '@@Objekt Operationen',
            GroupID: 'objectoperations',
            Index: 35,
            ParentID: null,
            Icon: 'wf_group_objectoperations'
        });
        WF_GROUP_REGISTRY.push({
            Caption: '@@AI Operationen',
            GroupID: 'aioperations',
            Index: 37,
            ParentID: null,
            Icon: 'wf_group_aioperations'
        });
        WF_GROUP_REGISTRY.push({
            Caption: '@@Datei Operationen',
            GroupID: 'fileoperations',
            Index: 38,
            ParentID: null,
            Icon: 'wf_group_fileoperations'
        });
        WF_GROUP_REGISTRY.push({
            Caption: '@@KPI Operationen',
            GroupID: 'kpioperations',
            Index: 39,
            ParentID: null,
            Icon: 'wf_group_kpioperations'
        });
        WF_GROUP_REGISTRY.push({
            Caption: '@@Dokument Operationen',
            GroupID: 'documentoperations',
            Index: 40,
            ParentID: null,
            Icon: 'wf_group_documentoperations'
        });
        

        // TypeInfos
        const relDataInfo = new WorkflowExitTypeInfo();
        relDataInfo.ID = 'relData';
        relDataInfo.Color = '#04B431';
        WF_TYPE_REGISTRY.set(relDataInfo.ID, relDataInfo);
        const objDataInfo = new WorkflowExitTypeInfo();
        objDataInfo.ID = 'objData';
        objDataInfo.Color = '#FF8000';
        WF_TYPE_REGISTRY.set(objDataInfo.ID, objDataInfo);
        const relDataEntryInfo = new WorkflowExitTypeInfo();
        relDataEntryInfo.ID = 'relDataEntry';
        relDataEntryInfo.Color = '#1c8547';
        WF_TYPE_REGISTRY.set(relDataEntryInfo.ID, relDataEntryInfo);
        const objDataEntryInfo = new WorkflowExitTypeInfo();
        objDataEntryInfo.ID = 'objDataEntry';
        objDataEntryInfo.Color = '#916711';
        WF_TYPE_REGISTRY.set(objDataEntryInfo.ID, objDataEntryInfo);
    }
}
